import { CampaignClass } from '../../campaigns';

/** Simplified campaign classes for easier dereferencing
 * Contains all campaign classes that are available to the user
 * and excludes deprecated campaign classes
 */
export enum ECampaignClass {
  retargeting = CampaignClass.Segment,
  mobileGeoFencing = CampaignClass.MobileGeoFencing,
  mobileGeoFenceRetargeting = CampaignClass.MobileGeoFenceRetargeting,
  facebook = CampaignClass.Facebook,
  emailListFacebook = CampaignClass.EmailListFacebook,
  emailList = CampaignClass.EmailList,
  search = CampaignClass.Search,
  seedSegment = CampaignClass.SeedSegment,
  affinity = CampaignClass.Affinity,
  googleAdsSmart = CampaignClass.GoogleAdsSmart,
  trackedLink = CampaignClass.TrackedLink,
  landingPage = CampaignClass.LandingPage,
  singleSend = CampaignClass.PinpointEmail,
  smartSend = CampaignClass.SmartPinpointEmail,
  autoSend = CampaignClass.AutoPinpointEmail,
  drip = CampaignClass.Drip,
  conversation = CampaignClass.Conversation,
  invites = CampaignClass.Referral,
  omni = CampaignClass.Omni,
}

export const {
  retargeting,
  mobileGeoFencing,
  mobileGeoFenceRetargeting,
  facebook,
  emailListFacebook,
  emailList,
  search,
  seedSegment,
  affinity,
  googleAdsSmart,
  trackedLink,
  landingPage,
  singleSend,
  smartSend,
  autoSend,
  drip,
  conversation,
  invites,
  omni,
} = ECampaignClass;
